document.addEventListener("DOMContentLoaded", function () {
  const quizRoots = document.querySelectorAll(".goddess-quiz");


  if (!quizRoots.length) return;


  if (!window.quizData || !window.quizData.questions || !window.quizData.goddesses) {
    console.error("Quiz data missing or invalid. Check goddess-quiz-data.js");
    return;
  }


  quizRoots.forEach(initQuiz);


  function initQuiz(quizRoot) {
    const baseQuizData = window.quizData;
    const quizData = {
      goddesses: baseQuizData.goddesses,
      questions: [...baseQuizData.questions]
    };


    const klaviyoPublicKey = (quizRoot.dataset.klaviyoPublicKey || "").trim();
    const klaviyoListId = (quizRoot.dataset.klaviyoListId || "").trim();
    const quizSource = quizRoot.dataset.quizSource || "goddess_quiz";
    const assetsBase = quizRoot.dataset.assetsBase || "";
    const storageKey = quizRoot.dataset.storageKey || "goddess_quiz_state";
    const REVEAL_STEP_MS = 650;
    const REVEAL_EXTRA_MS = 500;
    const SAVE_TTL_MS = 30 * 60 * 1000;
    const isThemeEditor = !!(window.Shopify && window.Shopify.designMode);


    function getTrackingApi() {
      return window.quizTracking || null;
    }


    async function safeTrack(callback) {
      try {
        if (typeof callback === "function") {
          return await callback();
        }
      } catch (error) {
        console.error("Quiz tracking error:", error);
      }
      return null;
    }


    function getCurrentQuizSessionId() {
      const tracking = getTrackingApi();


      if (tracking && typeof tracking.getSessionId === "function") {
        return tracking.getSessionId();
      }


      return localStorage.getItem("quiz_session_id") || "";
    }


    function saveQuizSessionToCart(callback) {
  const quizSessionId = getCurrentQuizSessionId();
  const quizResult = localStorage.getItem("quiz_result");
  const quizResultLabel = localStorage.getItem("quiz_result_label");

  const quizShadowResult = localStorage.getItem("quiz_shadow_result");
  const quizShadowResultLabel = localStorage.getItem("quiz_shadow_result_label");

  const formData = new FormData();

  // Segna l'ordine come proveniente dal quiz
  formData.append("note", "quiz");

  // Attributi puliti per Shopify / AfterSell / Flow
  formData.append("attributes[quiz_completed]", "yes");
  formData.append("attributes[quiz_source]", quizSource || "goddess_quiz");
  formData.append("attributes[quiz]", "yes");

  if (quizSessionId) {
    formData.append("attributes[_quiz_session_id]", quizSessionId);
    formData.append("attributes[quiz_session_id]", quizSessionId);
  }

  if (quizResult) {
    formData.append("attributes[_quiz_result]", quizResult);
    formData.append("attributes[quiz_result]", quizResult);
  }

  if (quizResultLabel) {
    formData.append("attributes[_quiz_result_label]", quizResultLabel);
    formData.append("attributes[quiz_result_label]", quizResultLabel);
  }

  if (quizShadowResult) {
    formData.append("attributes[_quiz_shadow_result]", quizShadowResult);
    formData.append("attributes[quiz_shadow_result]", quizShadowResult);
  }

  if (quizShadowResultLabel) {
    formData.append("attributes[_quiz_shadow_result_label]", quizShadowResultLabel);
    formData.append("attributes[quiz_shadow_result_label]", quizShadowResultLabel);
  }

  fetch("/cart/update.js", {
    method: "POST",
    body: formData
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      console.log("Cart updated:", data.attributes);

      if (typeof callback === "function") callback();
    })
    .catch(function (err) {
      console.error("Cart attribute error:", err);

      if (typeof callback === "function") callback();
    });
}


    let revealTimeoutId = null;
    let revealIntervalId = null;
    let revealCompletedCycle = false;


    const state = {
      currentQuestion: 0,
      selectedAnswers: [],
      finalDominant: null,
      finalSecond: null,
      finalPercentages: null,
      finalScores: null,
      leadSubmitted: false,
      shuffledQuestions: null
    };


    const intro = findInQuiz(quizRoot, '[data-screen="intro"]', ".quiz-intro");
    const questionScreen = findInQuiz(quizRoot, '[data-screen="question"]', ".quiz-question");
    const revealScreen = findInQuiz(quizRoot, '[data-screen="reveal"]', ".quiz-reveal");
    const emailGate = findInQuiz(quizRoot, '[data-screen="email"]', ".quiz-email-gate");
    const resultScreen = findInQuiz(quizRoot, '[data-screen="result"]', ".quiz-result");


    const startBtn = findInQuiz(quizRoot, '[data-role="start-quiz"]', ".quiz-start");
    const closeBtn = findInQuiz(quizRoot, '[data-role="close-quiz"]', ".quiz-close");
    const restartBtn = findInQuiz(quizRoot, '[data-role="restart-quiz"]', ".quiz-restart");


    const questionText = findInQuiz(quizRoot, '[data-role="question-text"]');
    const answersContainer = findInQuiz(quizRoot, '[data-role="answers-container"]');
    const questionCounter = findInQuiz(quizRoot, '[data-role="question-counter"]');
    const selectHint = findInQuiz(quizRoot, '[data-role="select-hint"]');


    const nextBtn = findInQuiz(quizRoot, '[data-role="next"]');
    const backBtn = findInQuiz(quizRoot, '[data-role="back-bottom"]');
    const backBtnTop = findInQuiz(quizRoot, '[data-role="back-top"]');
    const progressFill = findInQuiz(quizRoot, '[data-role="progress-fill"]');
    const progressSymbol = findInQuiz(quizRoot, '[data-role="progress-symbol"]');
    const revealRitual = findInQuiz(quizRoot, '[data-role="reveal-ritual"]');


    const emailForm = findInQuiz(quizRoot, '[data-role="lead-form"]');
    const quizEmailInput = findInQuiz(quizRoot, '[data-role="email-input"]');
    const quizConsent = findInQuiz(quizRoot, '[data-role="consent-input"]');
    const quizEmailSubmit = findInQuiz(quizRoot, '[data-role="email-submit"]');
    const quizEmailError = findInQuiz(quizRoot, '[data-role="email-error"]');
    const quizEmailSuccess = findInQuiz(quizRoot, '[data-role="email-success"]');
    const emailPreview = findInQuiz(quizRoot, '[data-role="email-preview"]');


    const resultName = findInQuiz(quizRoot, '[data-role="result-name"]');
    const resultHook = findInQuiz(quizRoot, '[data-role="result-hook"]');
    const resultSecondary = findInQuiz(quizRoot, '[data-role="result-secondary"]');
    const resultKeywords = findInQuiz(quizRoot, '[data-role="result-keywords"]');
    const resultIntro = findInQuiz(quizRoot, '[data-role="result-intro"]');
    const resultProof = findInQuiz(quizRoot, '[data-role="result-proof"]');
    const resultImage = findInQuiz(quizRoot, '[data-role="result-image"]');


    const aboutYou = findInQuiz(quizRoot, '[data-role="about-you"]');
    const aboutYouImage = findInQuiz(quizRoot, '[data-role="about-you-image"]');
    const aboutGoddessTitle = findInQuiz(quizRoot, '[data-role="about-goddess-title"]');
    const aboutGoddess = findInQuiz(quizRoot, '[data-role="about-goddess"]');
    const aboutGoddessImage = findInQuiz(quizRoot, '[data-role="about-goddess-image"]');
    const resultLogic = findInQuiz(quizRoot, '[data-role="result-logic"]');


    const percentBars = findInQuiz(quizRoot, '[data-role="percent-bars"]');
    const productGallery = findInQuiz(quizRoot, '[data-role="product-gallery"]');
    const productLink = findInQuiz(quizRoot, '[data-role="product-link"]');
    const productReasonEl = findInQuiz(quizRoot, '[data-role="product-reason"]');
    const shareTextEl = findInQuiz(quizRoot, '[data-role="share-text"]');
    const copyLinkBtn = findInQuiz(quizRoot, '[data-role="copy-link"]');
    const shareOnBtn = findInQuiz(quizRoot, '[data-role="share-on"]');
    const shareFeedback = findInQuiz(quizRoot, '[data-role="share-feedback"]');


    const productCatalogEl = findInQuiz(quizRoot, '[data-role="quiz-product-catalog"]');
    let productCatalog = {};


    if (productCatalogEl) {
      try {
        productCatalog = JSON.parse(productCatalogEl.textContent || "{}");
      } catch (error) {
        console.error("Quiz product catalog JSON invalid", error);
      }
    }


    if (!intro || !questionScreen || !revealScreen || !emailGate || !resultScreen || !startBtn || !questionText || !answersContainer) {
      console.error("Quiz: missing required elements");
      return;
    }


    hydrateRevealIcons();


    if (isThemeEditor) {
      clearSavedState();
      resetQuizState();
      shuffleQuestions();
      showScreen("intro");
      deactivateQuizLayout();
    } else {
      restoreState();
      ensureQuestionsReady();
      restoreVisibleScreen();
    }


    if (productLink) {
  productLink.addEventListener("click", function (e) {
    e.preventDefault();


    const targetUrl = productLink.href;


    trackQuizEvent("quiz_product_clicked", {
      result_key: state.finalDominant || "",
      product_url: targetUrl || ""
    });


    const dominant = quizData.goddesses[state.finalDominant];
    const goldProduct = getCatalogProduct(state.finalDominant);


    safeTrack(function () {
      const tracking = getTrackingApi();
      if (!tracking || typeof tracking.trackProductClick !== "function") return null;


      return tracking.trackProductClick({
        product_id: goldProduct ? goldProduct.handle || state.finalDominant : state.finalDominant,
        product_title: goldProduct && goldProduct.title ? goldProduct.title : (dominant ? dominant.name + " Necklace" : ""),
        variant_id: null,
        variant_title: ""
      });
    });


    saveQuizSessionToCart(function () {
      window.location.href = targetUrl;
    });
  });
}


    startBtn.addEventListener("click", async function () {
      localStorage.removeItem("quiz_session_id");
      sessionStorage.removeItem("quiz_session_created");
     
      resetQuizState();
      shuffleQuestions();
      clearTimeout(revealTimeoutId);
      stopRevealRitual();


      safeTrack(function () {
        const tracking = getTrackingApi();
        if (!tracking || typeof tracking.createQuizSession !== "function") return null;


        return tracking.createQuizSession({
          quiz_name: "Goddess Quiz",
          quiz_source: quizSource,
          section_id: quizRoot.dataset.sectionId || ""
        });
      });


      activateQuizLayout();
      showScreen("question");
      renderQuestion();
      saveState();


      trackQuizEvent("quiz_started", {
        quiz_name: "Goddess Quiz"
      });


      jumpToQuizTop(true);
    });


    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        closeQuiz();
      });
    }


    if (restartBtn) {
      restartBtn.addEventListener("click", function () {
        clearTimeout(revealTimeoutId);
        stopRevealRitual();
        clearSavedState();
        resetQuizState();
        shuffleQuestions();
        showScreen("intro");
        deactivateQuizLayout();
        if (emailForm) emailForm.reset();
        hideEmailMessages();
        hideShareFeedback();


        window.scrollTo({
          top: quizRoot.getBoundingClientRect().top + window.pageYOffset - 20,
          behavior: "smooth"
        });
      });
    }


    if (backBtn) {
      backBtn.addEventListener("click", function () {
        trackQuizEvent("quiz_back_clicked", {
          question_index: state.currentQuestion + 1
        });
        handleBack();
      });
    }


    if (backBtnTop) backBtnTop.style.display = "none";


    if (nextBtn) {
      nextBtn.addEventListener("click", async function () {
        const currentIndex = state.currentQuestion;
        const selectedIndex = state.selectedAnswers[currentIndex];


        if (selectedIndex === undefined) return;


        const question = quizData.questions[currentIndex];
        const answer = question && question.answers ? question.answers[selectedIndex] : null;


        if (question && answer) {
          const stableQuestionId = getQuestionStableId(question, currentIndex + 1);


          safeTrack(function () {
            const tracking = getTrackingApi();
            if (!tracking || typeof tracking.saveAnswer !== "function") return null;


            return tracking.saveAnswer({
              question_id: stableQuestionId,
              question_text: question.question,
              question_order: currentIndex + 1,
              answer_id: stableQuestionId + "_a" + (selectedIndex + 1),
              answer_text: answer.text,
              step_type: "question"
            });
          });
        }


        state.currentQuestion += 1;


        if (state.currentQuestion < quizData.questions.length) {
          renderQuestion();
          saveState();
        } else {
          prepareFinalResult();
          saveState();
          showReveal();
        }


        jumpToQuizTop();
      });
    }


    if (copyLinkBtn) {
      copyLinkBtn.addEventListener("click", async function () {
        const success = await copyTextToClipboard(window.location.href);


        if (success) {
          trackQuizEvent("quiz_result_shared", {
            result_key: state.finalDominant || "",
            share_method: "copy_link"
          });
        }


        showShareFeedback(success ? "Link copied." : "Could not copy link.");
      });
    }


    if (shareOnBtn) {
      shareOnBtn.addEventListener("click", async function () {
        const shareText = buildShareText();
        const shareUrl = window.location.href;


        if (navigator.share) {
          try {
            await navigator.share({
              title: "My Goddess Archetype",
              text: shareText,
              url: shareUrl
            });


            trackQuizEvent("quiz_result_shared", {
              result_key: state.finalDominant || "",
              share_method: "native"
            });


            showShareFeedback("Shared.");
          } catch (error) {
            if (error && error.name !== "AbortError") {
              const success = await copyTextToClipboard(shareUrl);


              if (success) {
                trackQuizEvent("quiz_result_shared", {
                  result_key: state.finalDominant || "",
                  share_method: "copy_link"
                });
              }


              showShareFeedback(success ? "Link copied." : "Could not share.");
            }
          }
        } else {
          const success = await copyTextToClipboard(shareUrl);


          if (success) {
            trackQuizEvent("quiz_result_shared", {
              result_key: state.finalDominant || "",
              share_method: "copy_link"
            });
          }


          showShareFeedback(success ? "Link copied." : "Sharing not available on this device.");
        }
      });
    }


    if (emailForm) {
  emailForm.addEventListener("submit", async function (e) {
    e.preventDefault();
    hideEmailMessages();


    const email = (quizEmailInput && quizEmailInput.value ? quizEmailInput.value : "").trim();
   
    if (!isValidEmail(email)) {
      showEmailError("Please enter a valid email address.");
      return;
    }


    if (quizEmailSubmit) {
      quizEmailSubmit.disabled = true;
    }


    try {
      if (klaviyoPublicKey) {
        try {
          await createOrUpdateKlaviyoProfile(email);
        } catch (klaviyoError) {
          console.error("Klaviyo failed, but result will still open:", klaviyoError);
        }
      } else {
        console.warn("Klaviyo public key missing, skipping Klaviyo profile creation.");
      }

      fetch(
       "https://egdxzzpkedciukkfrrwy.supabase.co/functions/v1/tag-shopify-customer",
       {
         method: "POST",
         headers: {
           "Content-Type": "application/json",
           "apikey": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVnZHh6enBrZWRjaXVra2Zycnd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1NjYyNDUsImV4cCI6MjA5MTE0MjI0NX0.35l4diqC1qspn-jEp_rHupFgUf5wAa15VIWLCjjcdbA",
           "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVnZHh6enBrZWRjaXVra2Zycnd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1NjYyNDUsImV4cCI6MjA5MTE0MjI0NX0.35l4diqC1qspn-jEp_rHupFgUf5wAa15VIWLCjjcdbA"
          },
          body: JSON.stringify({
            email: email,
            quiz_result: state.finalDominant || "",
            quiz_shadow_result: state.finalSecond || ""
          })
        }
      )
      .then(function (tagResponse) {
        return tagResponse.json().then(function (tagResult) {

          if (!tagResponse.ok || !tagResult.success) {
            console.error("Customer tagging failed:", tagResult);
          } else {
            console.log("Customer tagged successfully:", tagResult);
          }

        });
      })
      .catch(function (tagError) {
        console.error("Customer tagging failed:", tagError);
      });
     
      const quizSessionId = getCurrentQuizSessionId();


      if (quizSessionId) {
        fetch("https://egdxzzpkedciukkfrrwy.supabase.co/rest/v1/quiz_sessions?quiz_session_id=eq." + quizSessionId, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "apikey": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVnZHh6enBrZWRjaXVra2Zycnd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1NjYyNDUsImV4cCI6MjA5MTE0MjI0NX0.35l4diqC1qspn-jEp_rHupFgUf5wAa15VIWLCjjcdbA",
            "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVnZHh6enBrZWRjaXVra2Zycnd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1NjYyNDUsImV4cCI6MjA5MTE0MjI0NX0.35l4diqC1qspn-jEp_rHupFgUf5wAa15VIWLCjjcdbA"
          },
          body: JSON.stringify({
            email: email,
            quiz_shadow_result: state.finalSecond || ""
          })
        });
      }


      state.leadSubmitted = true;


     safeTrack(function () {
  const tracking = getTrackingApi();
  if (!tracking || typeof tracking.saveEmail !== "function") return null;


  return tracking.saveEmail(email);
});


trackQuizEvent("quiz_email_submitted", {
  result_key: state.finalDominant || ""
});


safeTrack(function () {
  const tracking = getTrackingApi();
  if (!tracking || typeof tracking.completeQuiz !== "function") return null;


  const dominant = quizData.goddesses[state.finalDominant];


  return tracking.completeQuiz({
    result_id: state.finalDominant || "",
    result_label: dominant ? dominant.name : ""
  });
});


trackQuizEvent("quiz_completed", {
  result_key: state.finalDominant || "",
  second_key: state.finalSecond || ""
});


saveState();
showEmailSuccess("Perfect. Your result is ready.");


setTimeout(function () {
  openResultScreen();
}, 500);


    } catch (error) {
      console.error("Email submit error:", error);


      trackQuizEvent("quiz_email_submit_failed", {
        result_key: state.finalDominant || "",
        error_message: error && error.message ? error.message.slice(0, 120) : "unknown"
      });


      showEmailError(error && error.message ? error.message : "Klaviyo error");
    } finally {
      if (quizEmailSubmit) {
        quizEmailSubmit.disabled = false;
      }
    }
  });
}


    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && quizRoot.classList.contains("active")) {
        closeQuiz();
      }
    });


    function createZeroScores() {
      return Object.keys(quizData.goddesses).reduce(function (acc, key) {
        acc[key] = 0;
        return acc;
      }, {});
    }


    function getScoreGap() {
      if (!state.finalScores) return null;


      const ranking = Object.entries(state.finalScores).sort(function (a, b) {
        return b[1] - a[1];
      });


      if (ranking.length < 2) return null;
      return ranking[0][1] - ranking[1][1];
    }


    function shuffleQuestions() {
      const shuffled = [...baseQuizData.questions];


      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = shuffled[i];
        shuffled[i] = shuffled[j];
        shuffled[j] = temp;
      }


      quizData.questions = shuffled;
      state.shuffledQuestions = shuffled.map(function (question) {
        return baseQuizData.questions.indexOf(question);
      });
    }


    function ensureQuestionsReady() {
      if (Array.isArray(state.shuffledQuestions) && state.shuffledQuestions.length === baseQuizData.questions.length) {
        quizData.questions = state.shuffledQuestions.map(function (index) {
          return baseQuizData.questions[index];
        });
      } else {
        shuffleQuestions();
      }
    }


    function hydrateRevealIcons() {
      if (!revealRitual) return;


      const icons = revealRitual.querySelectorAll(".reveal-icon[data-goddess]");
      icons.forEach(function (icon) {
        const key = icon.getAttribute("data-goddess");
        const goddess = quizData.goddesses[key];
        const src = goddess && goddess.medallionImage ? resolveAssetUrl(goddess.medallionImage) : "";


        icon.innerHTML = src
          ? '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(goddess.name) + '" loading="lazy">'
          : '<span class="reveal-icon-fallback"></span>';
      });
    }


    function renderQuestion() {
      const question = quizData.questions[state.currentQuestion];
      const selectedIndex = state.selectedAnswers[state.currentQuestion];


      if (!question) return;


      if (questionScreen) {
        questionScreen.style.opacity = "0";
        setTimeout(function () {
          questionScreen.style.opacity = "1";
        }, 30);
      }


      if (questionCounter) {
        questionCounter.textContent = "Question " + (state.currentQuestion + 1) + "/" + quizData.questions.length;
      }


      questionText.textContent = question.question;
      answersContainer.innerHTML = "";
      answersContainer.setAttribute("role", "radiogroup");
      answersContainer.setAttribute("aria-label", question.question);


      if (!answersContainer.classList.contains("quiz-answers-grid")) {
        answersContainer.classList.add("quiz-answers-grid");
      }


      question.answers.forEach(function (answer, index) {
        const card = document.createElement("button");
        card.type = "button";
        card.className = "answer-card";
        card.setAttribute("role", "radio");
        card.setAttribute("aria-checked", selectedIndex === index ? "true" : "false");


        if (index === 4) {
          card.classList.add("answer-card--full");
        }


        const imageUrl = resolveAssetUrl(answer.image);


        card.innerHTML =
          '<div class="answer-image">' +
            '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(answer.text) + '" loading="lazy">' +
          "</div>" +
          '<div class="answer-text">' +
            escapeHtml(answer.text) +
            '<span class="answer-check">✓</span>' +
          "</div>";


        if (selectedIndex === index) {
          card.classList.add("selected");
        }


        card.addEventListener("click", function () {
          state.selectedAnswers[state.currentQuestion] = index;


          answersContainer.querySelectorAll(".answer-card").forEach(function (c) {
            c.classList.remove("selected");
            c.setAttribute("aria-checked", "false");
          });


          card.classList.add("selected");
          card.setAttribute("aria-checked", "true");


          setNextButtonState(true);
          saveState();


          trackQuizEvent("quiz_answer_selected", {
            question_index: state.currentQuestion + 1,
            answer_index: index + 1
          });
        });


        answersContainer.appendChild(card);
      });


      setNextButtonState(selectedIndex !== undefined);
      updateNextButtonLabel();


      if (backBtn) {
        backBtn.style.visibility = state.currentQuestion === 0 ? "hidden" : "visible";
      }


      if (backBtnTop) {
        backBtnTop.style.display = "none";
      }


      updateProgress();
      showScreen("question");


      const stableQuestionId = getQuestionStableId(question, state.currentQuestion + 1);


      safeTrack(function () {
        const tracking = getTrackingApi();
        if (!tracking || typeof tracking.viewQuestion !== "function") return null;


        return tracking.viewQuestion({
          question_id: stableQuestionId,
          question_text: question.question,
          question_order: state.currentQuestion + 1,
          step_type: "question"
        });
      });


      focusQuestionTitle();
    }


    function handleBack() {
      clearTimeout(revealTimeoutId);
      stopRevealRitual();


      if (state.currentQuestion === 0) {
        showScreen("intro");
        deactivateQuizLayout();
        saveState();
        return;
      }


      state.currentQuestion -= 1;
      renderQuestion();
      saveState();
      jumpToQuizTop();
    }


    function closeQuiz() {
      clearTimeout(revealTimeoutId);
      stopRevealRitual();


      trackQuizEvent("quiz_exited", {
        question_index: state.currentQuestion + 1,
        answered_count: state.selectedAnswers.filter(function (value) {
          return value !== undefined;
        }).length,
        visible_screen: getVisibleScreen()
      });


      showScreen("intro");
      deactivateQuizLayout();
      saveState();


      const top = quizRoot.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: top, behavior: "smooth" });
    }


    function updateProgress() {
      if (!progressFill) return;


      const percent = ((state.currentQuestion + 1) / quizData.questions.length) * 100;
      progressFill.style.width = percent + "%";


      if (progressSymbol) {
        progressSymbol.style.left = percent + "%";
      }
    }


    function updateNextButtonLabel() {
      if (!nextBtn) return;


      const total = quizData.questions.length;
      const current = state.currentQuestion;


      if (current === total - 1) {
        nextBtn.textContent = "Reveal my goddess";
      } else if (current === total - 2) {
        nextBtn.textContent = "Final question";
      } else {
        nextBtn.textContent = "Next";
      }
    }


    function prepareFinalResult() {
  const scores = calculateScores();
  const percentages = calculatePercentages(scores);
  const ranking = rankResults(scores, percentages);


  state.finalDominant = ranking[0] ? ranking[0][0] : null;
  state.finalSecond = getPilotedSecondGoddess(state.finalDominant);


  state.finalPercentages = buildDisplayPercentages(ranking, state.finalDominant, state.finalSecond);
  state.finalScores = scores;


  const dominant = quizData.goddesses[state.finalDominant];


  localStorage.setItem('quiz_result', state.finalDominant || '');
  localStorage.setItem('quiz_result_label', dominant ? dominant.name : '');

  const secondGoddessData = quizData.goddesses[state.finalSecond];

  localStorage.setItem('quiz_shadow_result', state.finalSecond || '');
  localStorage.setItem(
    'quiz_shadow_result_label',
    secondGoddessData ? secondGoddessData.name : ''
  );




  // 🔥 NUOVO: salva su Supabase
  try {
    let quizSessionId = getCurrentQuizSessionId();
    const dominant = quizData.goddesses[state.finalDominant];


    if (!state.finalDominant) return;


    if (!quizSessionId) {
      quizSessionId = crypto.randomUUID();
      localStorage.setItem("quiz_session_id", quizSessionId);
    }


    const patchUrl = "https://egdxzzpkedciukkfrrwy.supabase.co/rest/v1/quiz_sessions?quiz_session_id=eq." + quizSessionId;


    fetch(patchUrl, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "apikey": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVnZHh6enBrZWRjaXVra2Zycnd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1NjYyNDUsImV4cCI6MjA5MTE0MjI0NX0.35l4diqC1qspn-jEp_rHupFgUf5wAa15VIWLCjjcdbA",
        "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVnZHh6enBrZWRjaXVra2Zycnd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1NjYyNDUsImV4cCI6MjA5MTE0MjI0NX0.35l4diqC1qspn-jEp_rHupFgUf5wAa15VIWLCjjcdbA",
        "Prefer": "return=minimal"
      },
      body: JSON.stringify({
        result_id: state.finalDominant,
        result_label: dominant ? dominant.name : state.finalDominant
      })
    }).catch(err => console.error("Supabase error:", err));


  } catch (e) {
    console.error("Result save failed:", e);
  }
}
    function getPilotedSecondGoddess(dominantKey) {
      if (!dominantKey) return null;
      return dominantKey === "medusa" ? "persephone" : "medusa";
    }

    function calculateScores() {
      const scores = createZeroScores();


      state.selectedAnswers.forEach(function (selectedIndex, questionIndex) {
        const question = quizData.questions[questionIndex];
        if (!question) return;


        const answer = question.answers[selectedIndex];
        if (!answer || !answer.scores) return;


        Object.keys(answer.scores).forEach(function (goddessKey) {
          if (scores[goddessKey] === undefined) {
            scores[goddessKey] = 0;
          }
          scores[goddessKey] += answer.scores[goddessKey];
        });
      });


      return scores;
    }


    function calculatePercentages(scores) {
      const total = Object.values(scores).reduce(function (sum, value) {
        return sum + value;
      }, 0);


      const result = {};
      Object.keys(scores).forEach(function (key) {
        result[key] = total > 0 ? Math.round((scores[key] / total) * 100) : 0;
      });


      return result;
    }


    function normalizePercentages(percentages, dominantKey) {
      const normalized = Object.assign({}, percentages);
      const total = Object.values(normalized).reduce(function (sum, value) {
        return sum + value;
      }, 0);
      const diff = 100 - total;


      if (dominantKey && normalized[dominantKey] !== undefined) {
        normalized[dominantKey] += diff;
      }


      return normalized;
    }

    function buildDisplayPercentages(ranking, dominantKey, secondKey) {
      const display = createZeroScores();

      if (!ranking || !ranking.length) return display;

      const orderedValues = [70, 20, 4, 2.5, 1.5, 1.2, 0.8];

      // Costruisce l'ordine di visualizzazione: dominante reale, poi la dea pilotata come seconda,
      // poi le rimanenti nell'ordine del ranking reale (esclusi dominante e pilotata).
      const remaining = ranking
        .map(function (entry) { return entry[0]; })
        .filter(function (key) { return key !== dominantKey && key !== secondKey; });

      const displayOrder = [dominantKey, secondKey].concat(remaining);

      displayOrder.forEach(function (key, index) {
        if (!key) return;
        if (orderedValues[index] !== undefined) {
          display[key] = orderedValues[index];
        }
      });

      return display;
    }


    function rankResults(scores, percentages) {
      const maxHits = countMaxHits();


      return Object.keys(scores)
        .map(function (key) {
          return [key, { score: scores[key], percentage: percentages[key], maxHits: maxHits[key] }];
        })
        .sort(function (a, b) {
          if (b[1].score !== a[1].score) return b[1].score - a[1].score;
          if (b[1].maxHits !== a[1].maxHits) return b[1].maxHits - a[1].maxHits;
          if (b[1].percentage !== a[1].percentage) return b[1].percentage - a[1].percentage;
          return 0;
        });
    }


    function countMaxHits() {
      const hits = createZeroScores();


      state.selectedAnswers.forEach(function (selectedIndex, questionIndex) {
        const question = quizData.questions[questionIndex];
        if (!question) return;


        const answer = question.answers[selectedIndex];
        if (!answer || !answer.scores) return;


        const values = Object.values(answer.scores);
        if (!values.length) return;


        const maxValue = Math.max.apply(null, values);


        Object.keys(answer.scores).forEach(function (key) {
          if (answer.scores[key] === maxValue) {
            hits[key] += 1;
          }
        });
      });


      return hits;
    }


    function showReveal() {
      showScreen("reveal");
      jumpToQuizTop();


      trackQuizEvent("quiz_reveal_viewed", {
        result_key: state.finalDominant || ""
      });


      clearTimeout(revealTimeoutId);
      revealCompletedCycle = false;
      startRevealRitual();


      const revealIconsCount = revealRitual
        ? revealRitual.querySelectorAll(".reveal-icon").length
        : 5;


      const minimumRevealDuration = (revealIconsCount * REVEAL_STEP_MS) + REVEAL_EXTRA_MS;


      revealTimeoutId = setTimeout(function checkRevealCompletion() {
        if (!revealCompletedCycle) {
          revealTimeoutId = setTimeout(checkRevealCompletion, 120);
          return;
        }


        stopRevealRitual();
        showScreen("email");
        saveState();
        jumpToQuizTop();
      }, minimumRevealDuration);
    }


    function startRevealRitual() {
      if (!revealRitual) return;


      const icons = revealRitual.querySelectorAll(".reveal-icon");
      if (!icons.length) return;


      icons.forEach(function (icon) {
        icon.classList.remove("active", "done");
      });


      let current = 0;
      revealCompletedCycle = false;


      clearInterval(revealIntervalId);


      revealIntervalId = setInterval(function () {
        icons.forEach(function (icon, index) {
          icon.classList.remove("active");


          if (index < current) {
            icon.classList.add("done");
          } else {
            icon.classList.remove("done");
          }
        });


        if (icons[current]) {
          icons[current].classList.add("active");
        }


        current += 1;


        if (current >= icons.length) {
          revealCompletedCycle = true;
          current = 0;


          icons.forEach(function (icon) {
            icon.classList.remove("done");
          });
        }
      }, REVEAL_STEP_MS);
    }


    function stopRevealRitual() {
      clearInterval(revealIntervalId);
      revealIntervalId = null;
      revealCompletedCycle = false;


      if (!revealRitual) return;


      const icons = revealRitual.querySelectorAll(".reveal-icon");
      icons.forEach(function (icon) {
        icon.classList.remove("active", "done");
      });
    }


    function openResultScreen() {
      showScreen("result");
      renderResult(state.finalDominant, state.finalSecond, state.finalPercentages);

      // Salva risultato quiz nel carrello appena viene mostrato il risultato
      saveQuizSessionToCart();

      saveState();
      jumpToQuizTop();
    }


    function renderResult(mainKey, secondKey, percentages) {
      const goddess = quizData.goddesses[mainKey];
      const secondGoddess = quizData.goddesses[secondKey];


      if (!goddess) return;


      if (resultName) resultName.textContent = goddess.name;
      if (resultHook) resultHook.textContent = getResultHook(goddess);


      if (resultSecondary) {
        const gap = getScoreGap();


        if (secondGoddess && secondGoddess.name !== goddess.name) {
          resultSecondary.textContent = gap !== null && gap <= 1
            ? "Primary archetype: " + goddess.name + " • Secondary energy: " + secondGoddess.name
            : "Secondary energy: " + secondGoddess.name;
          resultSecondary.style.display = "block";
        } else {
          resultSecondary.style.display = "none";
          resultSecondary.textContent = "";
        }
      }


      if (resultKeywords) resultKeywords.textContent = goddess.keywords.join(" • ");
      if (resultIntro) resultIntro.textContent = buildResultIntro(goddess, secondGoddess);


      if (resultProof) {
        resultProof.textContent = "This may feel familiar — even if you’ve never put it into words.";
      }


      if (resultImage) {
        resultImage.src = resolveAssetUrl(goddess.image);
        resultImage.alt = goddess.name + " hero image";
        resultImage.onerror = function () {
          this.style.display = "none";
        };
        resultImage.style.display = "block";
      }


      if (aboutYou) {
        aboutYou.textContent =
          "This is something you’ve likely felt for a long time — even if you’ve never fully named it. " +
          goddess.aboutYou;
      }


      if (aboutYouImage) {
        aboutYouImage.src = resolveAssetUrl(goddess.aboutYouImage || goddess.image);
        aboutYouImage.alt = goddess.name + " about you image";
        aboutYouImage.onerror = function () {
          this.style.display = "none";
        };
        aboutYouImage.style.display = "block";
      }


      if (aboutGoddessTitle) {
        aboutGoddessTitle.textContent = "About " + goddess.name;
      }


      if (aboutGoddess) {
        aboutGoddess.textContent = goddess.aboutGoddess;
      }


      if (aboutGoddessImage) {
        aboutGoddessImage.src = resolveAssetUrl(goddess.aboutGoddessImage || goddess.image);
        aboutGoddessImage.alt = goddess.name + " goddess image";
        aboutGoddessImage.onerror = function () {
          this.style.display = "none";
        };
        aboutGoddessImage.style.display = "block";
      }


      if (resultLogic) {
        resultLogic.textContent = getResultLogic(goddess);
      }


      if (productLink) {
        const goldProduct = getCatalogProduct(mainKey);
      const primaryProductUrl = (goldProduct && goldProduct.url) || "#";


      productLink.href = appendQuizParams(primaryProductUrl, mainKey);
      productLink.textContent = getProductCTA(goddess);
      }


      if (productReasonEl) {
        productReasonEl.textContent = buildProductReason(goddess);
      }


      if (shareTextEl) {
        shareTextEl.textContent = buildShareText();
      }


      renderProductGallery(goddess);
      renderPercentages(percentages);


      safeTrack(function () {
        const tracking = getTrackingApi();
        if (!tracking || typeof tracking.trackProductView !== "function") return null;


        const goldProduct = getCatalogProduct(mainKey);


        return tracking.trackProductView({
          product_id: goldProduct ? goldProduct.handle || mainKey : mainKey,
          product_title: goldProduct && goldProduct.title ? goldProduct.title : (goddess ? goddess.name + " Necklace" : ""),
          variant_id: null,
          variant_title: ""
        });
      });


      hideShareFeedback();
    }


    function getCatalogProduct(resultKey) {
      if (!resultKey) return null;
      if (!productCatalog || !productCatalog[resultKey]) return null;
      const products = productCatalog[resultKey];
      return Array.isArray(products) && products.length > 0 ? products[0] : null;
    }


    function getDiscountPercent(priceString, compareAtPriceString) {
      if (!priceString || !compareAtPriceString) return null;


      const price = parseFloat(String(priceString).replace(/[^\d.]/g, ""));
      const compare = parseFloat(String(compareAtPriceString).replace(/[^\d.]/g, ""));


      if (!Number.isFinite(price) || !Number.isFinite(compare) || compare <= price) {
        return null;
      }


      return Math.round(((compare - price) / compare) * 100);
    }


    function getStockMessage(product) {
      if (!product) return "";


      const available = !!product.available;
      const inventoryQty = Number(product.inventoryQuantity);
      const inventoryPolicy = product.inventoryPolicy || "";
      const incoming = !!product.incoming;


      if (!available) {
        return "Join the waitlist";
      }


      if (inventoryPolicy === "continue" && (!Number.isFinite(inventoryQty) || inventoryQty <= 0)) {
        return incoming ? "Pre-order available" : "Available on backorder";
      }


      if (Number.isFinite(inventoryQty)) {
        if (inventoryQty <= 3) {
          return "Only a few pieces left";
        }


        if (inventoryQty <= 8) {
          return "Limited stock";
        }
      }


      return "Available now";
    }


    function renderProductGallery(goddess) {
      if (!productGallery || !goddess || !state.finalDominant) return;


      const catalogProducts = productCatalog[state.finalDominant];
      if (!catalogProducts || !Array.isArray(catalogProducts)) return;


      const items = catalogProducts.map(function(product) {
        return {
          title: product.title || (goddess.name + " Necklace"),
          image: product.image || "",
          url: product.url || "#",
          price: product.price || "",
          compareAtPrice: product.compareAtPrice || "",
          onSale: !!product.onSale,
          discountPercent: getDiscountPercent(product.price, product.compareAtPrice),
          stockMessage: getStockMessage(product),
          productId: product.handle || state.finalDominant,
          variantId: null,
          variantTitle: ""
        };
      });


      productGallery.innerHTML = items.map(function (item) {
        const cardUrl = appendQuizParams(item.url || "#", state.finalDominant || "");
        const priceHtml = item.onSale && item.compareAtPrice
          ? (
              '<div class="quiz-product-price-wrap">' +
                '<p class="quiz-product-price quiz-product-price-sale">' + escapeHtml(item.price) + '</p>' +
                '<p class="quiz-product-compare-price">' + escapeHtml(item.compareAtPrice) + '</p>' +
              '</div>'
            )
          : (
              item.price
                ? '<p class="quiz-product-price">' + escapeHtml(item.price) + '</p>'
                : ''
            );


        return (
          '<div class="quiz-product-card">' +
            '<a href="' + escapeHtml(cardUrl) + '" class="quiz-product-card-link" ' +
              'data-product-id="' + escapeHtml(item.productId || "") + '" ' +
              'data-product-title="' + escapeHtml(item.title || "") + '" ' +
              'data-variant-id="' + escapeHtml(item.variantId || "") + '" ' +
              'data-variant-title="' + escapeHtml(item.variantTitle || "") + '">' +
              '<div class="quiz-product-image-wrap">' +
                (item.discountPercent
                  ? '<div class="quiz-product-badge">-' + item.discountPercent + '%</div>'
                  : '') +
                (item.image
                  ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
                  : '') +
              '</div>' +
              '<div class="quiz-product-info">' +
                '<h4 class="quiz-product-title">' + escapeHtml(item.title) + '</h4>' +
                priceHtml +
                (item.stockMessage
                  ? '<p class="quiz-product-stock">' + escapeHtml(item.stockMessage) + '</p>'
                  : '') +
                '' +
              '</div>' +
            '</a>' +
          '</div>'
        );
      }).join("");


      const galleryImages = productGallery.querySelectorAll("img");
      galleryImages.forEach(function (img) {
        img.onerror = function () {
          const card = this.closest(".quiz-product-card");
          if (card) card.classList.add("quiz-product-card--image-error");
          this.style.opacity = "0";
        };
      });


      const galleryLinks = productGallery.querySelectorAll(".quiz-product-card-link");
      galleryLinks.forEach(function (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();

          const targetUrl = link.href;

          const productId = link.getAttribute("data-product-id") || "";
          const productTitle = link.getAttribute("data-product-title") || "";
          const variantId = link.getAttribute("data-variant-id") || null;
          const variantTitle = link.getAttribute("data-variant-title") || null;

          safeTrack(function () {
            const tracking = getTrackingApi();
            if (!tracking || typeof tracking.trackProductClick !== "function") return null;

            return tracking.trackProductClick({
              product_id: productId,
              product_title: productTitle,
              variant_id: variantId,
              variant_title: variantTitle
            });
          });

          saveQuizSessionToCart(function () {
            window.location.href = targetUrl;
          });
        });
      });
    }


    function buildResultIntro(goddess, secondGoddess) {
      if (!goddess) return "";


      let text =
        goddess.resultIntro + " " +
        "This is the energy that defines how you move, choose, and connect. " +
        "You don’t need to become this. You already are.";


      if (secondGoddess && secondGoddess.name !== goddess.name) {
        text += " Beneath that, there is also a strong " + secondGoddess.name +
          " current shaping how you protect yourself and respond to the world.";
      }


      return text;
    }


    function getResultHook(goddess) {
      if (!goddess) return "";


      if (goddess.name === "Athena") {
        return "You don’t move blindly. You understand first, then act.";
      }


      if (goddess.name === "Persephone") {
        return "There is more happening beneath your surface than most people ever see.";
      }


      if (goddess.name === "Medusa") {
        return "You feel truth instantly. You no longer ignore it.";
      }


      if (goddess.name === "Cleopatra") {
        return "You are not meant to be overlooked. You are done playing small.";
      }


      if (goddess.name === "Aphrodite") {
        return "You don't chase. You draw things toward you.";
      }


      if (goddess.name === "Hecate") {
        return "You have walked through your own darkness. You know things others are still afraid to face.";
      }


      if (goddess.name === "Artemis") {
        return "You have never needed permission to be who you are. You never will.";
      }


      return "";
    }


    function getResultLogic(goddess) {
      if (!goddess) return "";


      if (goddess.name === "Athena") {
        return "Across your answers, a clear pattern appeared: you don’t react impulsively — you observe, understand, and then move. That kind of clarity is rare, and it shaped your result.";
      }


      if (goddess.name === "Persephone") {
        return "Your answers showed a consistent pull inward — toward depth, feeling, and internal processing. This pattern points to a deeply intuitive and evolving nature.";
      }


      if (goddess.name === "Medusa") {
        return "You consistently responded to protect your energy, read situations instantly, and close off what doesn’t feel right. That clarity of instinct shaped this result.";
      }


      if (goddess.name === "Cleopatra") {
        return "Your answers revealed a natural tendency to take space, lead, and define your environment — rather than adapt to it. That presence shaped your result.";
      }


      if (goddess.name === "Aphrodite") {
        return "You repeatedly chose connection, energy, and emotional alignment over logic or control. That sensitivity to what feels alive shaped your result.";
      }


      if (goddess.name === "Hecate") {
        return "Your answers revealed a consistent pattern: you process alone, you survive quietly, and you emerge knowing things others don't. That depth shaped this result.";
      }


      if (goddess.name === "Artemis") {
        return "You consistently chose independence, self-containment, and freedom over validation or belonging. That clarity shaped this result.";
      }


      return "";
    }


    function buildProductReason(goddess) {
      if (!goddess) return "";


      if (goddess.name === "Athena") {
        return "Designed for clarity and self-trust — a piece that reflects your ability to see clearly and move with intention.";
      }


      if (goddess.name === "Persephone") {
        return "A piece that reflects your depth — for the part of you that transforms, feels deeply, and evolves quietly.";
      }


      if (goddess.name === "Medusa") {
        return "A symbol of protection — for the part of you that no longer allows what isn’t right to stay.";
      }


      if (goddess.name === "Cleopatra") {
        return "A piece that mirrors your presence — for the woman who knows her value and doesn’t shrink.";
      }


      if (goddess.name === "Aphrodite") {
        return "A piece that reflects your magnetism — for the energy that attracts without chasing.";
      }


      if (goddess.name === "Hecate") {
        return "A symbol for the woman who has faced every shadow and chosen herself anyway. Ancient. Sovereign. Untouchable.";
      }


      if (goddess.name === "Artemis") {
        return "A piece for the woman who moves on her own terms. Who guards her energy like sacred ground.";
      }


      return "";
    }


    function getProductCTA(goddess) {
      if (!goddess) return "View your piece";


      if (goddess.name === "Athena") return "View your piece";
      if (goddess.name === "Persephone") return "View your piece";
      if (goddess.name === "Medusa") return "Wear your protection";
      if (goddess.name === "Cleopatra") return "Own your presence";
      if (goddess.name === "Aphrodite") return "Wear your magnetism";
      if (goddess.name === "Hecate") return "Carry her power";
      if (goddess.name === "Artemis") return "Wear your freedom";


      return "View your piece";
    }


    function buildShareText() {
      if (!state.finalDominant || !quizData.goddesses[state.finalDominant]) {
        return "I just took this quiz.";
      }


      const goddess = quizData.goddesses[state.finalDominant];
      return "I took this goddess archetype quiz and got " + goddess.name + ". Now I’m curious which one you’d get.";
    }


    function renderPercentages(percentages) {
      if (!percentBars || !percentages) return;


      percentBars.innerHTML = "";


      const sorted = Object.entries(percentages).sort(function (a, b) {
        return b[1] - a[1];
      });


      sorted.forEach(function (entry) {
        const key = entry[0];
        const value = entry[1];
        const goddess = quizData.goddesses[key];
        if (!goddess) return;


        const medallionSrc = goddess.medallionImage ? resolveAssetUrl(goddess.medallionImage) : "";


        const row = document.createElement("div");
        row.className = "percent-bar";
        row.innerHTML =
          '<div class="percent-bar-top">' +
            '<span class="percent-bar-name">' +
              '<span class="goddess-medallion goddess-medallion--image">' +
                (medallionSrc
                  ? '<img src="' + escapeHtml(medallionSrc) + '" alt="' + escapeHtml(goddess.name) + '" loading="lazy">'
                  : '<span class="goddess-medallion-fallback"></span>') +
              '</span>' +
              '<span class="goddess-medallion-label">' + escapeHtml(goddess.name) + '</span>' +
            '</span>' +
            '<span>' + value + '%</span>' +
          '</div>' +
          '<div class="percent-bar-track">' +
            '<div class="percent-bar-fill" style="width:' + value + '%"></div>' +
          '</div>';


        percentBars.appendChild(row);
      });


      const medallionImages = percentBars.querySelectorAll(".goddess-medallion img");
      medallionImages.forEach(function (img) {
        img.onerror = function () {
          const wrapper = this.parentElement;
          if (wrapper) {
            wrapper.innerHTML = '<span class="goddess-medallion-fallback"></span>';
          }
        };
      });
    }


    async function createOrUpdateKlaviyoProfile(email) {
      const dominantGoddess = quizData.goddesses[state.finalDominant];
      const secondGoddess = quizData.goddesses[state.finalSecond];


      const profilePayload = {
        data: {
          type: "profile",
          attributes: {
            email: email,
            properties: {
              quiz_source: quizSource,
              quiz_name: "Goddess Quiz",
              goddess_result: dominantGoddess ? dominantGoddess.name : "",
              goddess_result_key: state.finalDominant || "",
              goddess_secondary: secondGoddess ? secondGoddess.name : "",
              goddess_secondary_key: state.finalSecond || "",
              goddess_percentages: state.finalPercentages || {},
              quiz_completed_at: new Date().toISOString(),
              quiz_marketing_consent: true
            }
          }
        }
      };


      const profileResponse = await fetch(
        "https://a.klaviyo.com/client/profiles?company_id=" + encodeURIComponent(klaviyoPublicKey),
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            revision: "2024-07-15"
          },
          body: JSON.stringify(profilePayload)
        }
      );


      if (!profileResponse.ok) {
        const errorText = await safeReadText(profileResponse);
        throw new Error("Klaviyo profile error " + profileResponse.status + ": " + (errorText || "Unknown error"));
      }


      if (klaviyoListId) {
        const subscribePayload = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: klaviyoListId
                }
              }
            }
          }
        };


        const subscribeResponse = await fetch(
          "https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(klaviyoPublicKey),
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              revision: "2024-07-15"
            },
            body: JSON.stringify(subscribePayload)
          }
        );


        if (!subscribeResponse.ok) {
          const errorText = await safeReadText(subscribeResponse);
          throw new Error("Klaviyo subscription error " + subscribeResponse.status + ": " + (errorText || "Unknown error"));
        }
      }


      return true;
    }


    function showEmailError(message) {
      if (!quizEmailError || !quizEmailSuccess) return;
      quizEmailError.textContent = message;
      quizEmailError.style.display = "block";
      quizEmailSuccess.style.display = "none";
    }


    function showEmailSuccess(message) {
      if (!quizEmailError || !quizEmailSuccess) return;
      quizEmailSuccess.textContent = message;
      quizEmailSuccess.style.display = "block";
      quizEmailError.style.display = "none";
    }


    function hideEmailMessages() {
      if (quizEmailError) quizEmailError.style.display = "none";
      if (quizEmailSuccess) quizEmailSuccess.style.display = "none";
    }


    function showShareFeedback(message) {
      if (!shareFeedback) return;
      shareFeedback.textContent = message;
      shareFeedback.style.display = "block";
    }


    function hideShareFeedback() {
      if (!shareFeedback) return;
      shareFeedback.style.display = "none";
      shareFeedback.textContent = "";
    }


    function setNextButtonState(enabled) {
      if (!nextBtn) return;


      nextBtn.disabled = !enabled;
      nextBtn.setAttribute("aria-disabled", enabled ? "false" : "true");


      if (selectHint) {
        selectHint.style.display = enabled ? "none" : "block";
      }
    }


    function trackQuizEvent(eventName, payload) {
      try {
        const eventPayload = {
          quiz_source: quizSource,
          ...(payload || {})
        };


        if (window.dataLayer) {
          window.dataLayer.push({
            event: eventName,
            ...eventPayload
          });
        }


        if (typeof window.fbq === "function") {
          window.fbq("trackCustom", eventName, eventPayload);
        }
      } catch (error) {}
    }


    async function copyTextToClipboard(text) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
          return true;
        }


        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        const success = document.execCommand("copy");
        document.body.removeChild(textarea);
        return success;
      } catch (error) {
        return false;
      }
    }


    function getActiveScreenElement() {
      if (questionScreen && questionScreen.style.display !== "none") return questionScreen;
      if (revealScreen && revealScreen.style.display !== "none") return revealScreen;
      if (emailGate && emailGate.style.display !== "none") return emailGate;
      if (resultScreen && resultScreen.style.display !== "none") return resultScreen;
      return quizRoot;
    }


    function jumpToQuizTop(isInitialOpen) {
      const isMobileOverlay = window.innerWidth < 992 && quizRoot.classList.contains("active");


      if (isMobileOverlay) {
        quizRoot.scrollTop = 0;
        return;
      }


      const target = getActiveScreenElement();
      const offset = isInitialOpen ? 8 : 20;
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;


      window.scrollTo({
        top: top,
        behavior: "auto"
      });
    }


    function focusQuestionTitle() {
      window.requestAnimationFrame(function () {
        if (questionText) questionText.focus();
      });
    }


    function showScreen(screenName) {
      const screens = [
        { name: "intro", el: intro, display: "flex" },
        { name: "question", el: questionScreen, display: "flex" },
        { name: "reveal", el: revealScreen, display: "flex" },
        { name: "email", el: emailGate, display: "flex" },
        { name: "result", el: resultScreen, display: "flex" }
      ];


      screens.forEach(function (screen) {
        if (!screen.el) return;
        screen.el.style.display = screen.name === screenName ? screen.display : "none";
      });


      if (closeBtn) {
        closeBtn.style.display = screenName === "intro" ? "none" : "block";
      }


      if (screenName === "email") {
        const goddess = quizData.goddesses[state.finalDominant];


        if (emailPreview && goddess) {
          emailPreview.textContent = "Your result is ready: " + goddess.name + ". Enter your email to unlock the full reading.";
          emailPreview.style.display = "block";
        }


        trackQuizEvent("quiz_email_gate_viewed", {
          result_key: state.finalDominant || ""
        });


        safeTrack(function () {
          const tracking = getTrackingApi();
          if (!tracking || typeof tracking.viewQuestion !== "function") return null;


          return tracking.viewQuestion({
            question_id: "email_gate",
            question_text: "Email gate",
            question_order: quizData.questions.length + 1,
            step_type: "email"
          });
        });
      }


      if (screenName === "result") {
        trackQuizEvent("quiz_result_viewed", {
          result_key: state.finalDominant || ""
        });


        safeTrack(function () {
          const tracking = getTrackingApi();
          if (!tracking || typeof tracking.viewResult !== "function") return null;


          const dominant = quizData.goddesses[state.finalDominant];


          return tracking.viewResult({
            result_id: state.finalDominant || "",
            result_label: dominant ? dominant.name : ""
          });
        });
      }
    }


    function activateQuizLayout() {
      quizRoot.classList.add("active");


      if (window.innerWidth < 992) {
        document.body.classList.add("quiz-open");
      }
    }


    function deactivateQuizLayout() {
      quizRoot.classList.remove("active");
      document.body.classList.remove("quiz-open");
      if (closeBtn) closeBtn.style.display = "none";
    }


    function resolveAssetUrl(filename) {
      if (!filename) return "";
      if (/^https?:\/\//i.test(filename) || filename.indexOf("//") === 0 || filename.indexOf("/") === 0) {
        return filename;
      }
      return assetsBase + filename;
    }


    function appendQuizParams(url, resultKey) {
  if (!url || url === "#") return url;


  const quizSessionId = getCurrentQuizSessionId();
  const separator = url.indexOf("?") === -1 ? "?" : "&";


  return (
    url +
    separator +
    "source=quiz" +
    "&result=" + encodeURIComponent(resultKey || "") +
    "&properties[_quiz_session_id]=" + encodeURIComponent(quizSessionId || "")
  );
}


    function getQuestionStableId(question, fallbackIndex) {
     if (!question) return "unknown_question";
     return question.id || ("question_" + fallbackIndex);
    }


    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }


    async function safeReadText(response) {
      try {
        return await response.text();
      } catch (e) {
        return "";
      }
    }


    function escapeHtml(str) {
      return String(str)
        .split("&").join("&amp;")
        .split("<").join("&lt;")
        .split(">").join("&gt;")
        .split('"').join("&quot;")
        .split("'").join("&#039;");
    }


    function saveState() {
      if (isThemeEditor) return;


      const payload = {
        savedAt: Date.now(),
        currentQuestion: state.currentQuestion,
        selectedAnswers: state.selectedAnswers,
        finalDominant: state.finalDominant,
        finalSecond: state.finalSecond,
        finalPercentages: state.finalPercentages,
        finalScores: state.finalScores,
        leadSubmitted: state.leadSubmitted,
        visibleScreen: getVisibleScreen(),
        shuffledQuestions: state.shuffledQuestions
      };


      try {
        localStorage.setItem(storageKey, JSON.stringify(payload));
      } catch (error) {}
    }


    function clearSavedState() {
      try {
        localStorage.removeItem(storageKey);
      } catch (error) {}
    }


    function resetQuizState() {
      state.currentQuestion = 0;
      state.selectedAnswers = [];
      state.finalDominant = null;
      state.finalSecond = null;
      state.finalPercentages = null;
      state.finalScores = null;
      state.leadSubmitted = false;
      state.shuffledQuestions = null;
    }


    function restoreState() {
      try {
        const raw = localStorage.getItem(storageKey);
        if (!raw) return;


        const saved = JSON.parse(raw);
        if (!saved || typeof saved !== "object") return;


        const isExpired = !saved.savedAt || (Date.now() - saved.savedAt > SAVE_TTL_MS);


        if (isExpired) {
          clearSavedState();
          return;
        }


        const totalQuestions = baseQuizData.questions.length;


        state.currentQuestion =
          Number.isInteger(saved.currentQuestion) &&
          saved.currentQuestion >= 0 &&
          saved.currentQuestion <= totalQuestions
            ? saved.currentQuestion
            : 0;


        state.selectedAnswers = Array.isArray(saved.selectedAnswers)
          ? saved.selectedAnswers.slice(0, totalQuestions).map(function (value, questionIndex) {
              if (!Number.isInteger(value)) return undefined;


              const sourceQuestionIndex =
                Array.isArray(saved.shuffledQuestions) &&
                Number.isInteger(saved.shuffledQuestions[questionIndex])
                  ? saved.shuffledQuestions[questionIndex]
                  : questionIndex;


              const sourceQuestion = baseQuizData.questions[sourceQuestionIndex];
              const answersCount = sourceQuestion && sourceQuestion.answers ? sourceQuestion.answers.length : 0;


              if (value < 0 || value >= answersCount) return undefined;
              return value;
            })
          : [];


        state.finalDominant = saved.finalDominant || null;
        state.finalSecond = saved.finalSecond || null;
        state.finalPercentages = saved.finalPercentages || null;
        state.finalScores = saved.finalScores || null;
        state.leadSubmitted = !!saved.leadSubmitted;
        state.shuffledQuestions = Array.isArray(saved.shuffledQuestions) ? saved.shuffledQuestions : null;
      } catch (error) {
        clearSavedState();
      }
    }


    function restoreVisibleScreen() {
      let visibleScreen = "intro";


      try {
        const raw = localStorage.getItem(storageKey);
        if (raw) {
          const saved = JSON.parse(raw);
          const isExpired = !saved.savedAt || (Date.now() - saved.savedAt > SAVE_TTL_MS);


          if (isExpired) {
            clearSavedState();
            visibleScreen = "intro";
          } else if (saved && saved.visibleScreen) {
            visibleScreen = saved.visibleScreen;
          }
        }
      } catch (error) {
        clearSavedState();
      }


      if (visibleScreen === "question") {
        activateQuizLayout();
        renderQuestion();
        return;
      }


      if (visibleScreen === "reveal" && state.finalDominant) {
        activateQuizLayout();
        showScreen("reveal");


        clearTimeout(revealTimeoutId);
        startRevealRitual();


        const revealIconsCount = revealRitual
          ? revealRitual.querySelectorAll(".reveal-icon").length
          : 5;


        const minimumRevealDuration = (revealIconsCount * REVEAL_STEP_MS) + REVEAL_EXTRA_MS;


        revealCompletedCycle = false;


        revealTimeoutId = setTimeout(function checkRevealCompletion() {
          if (!revealCompletedCycle) {
            revealTimeoutId = setTimeout(checkRevealCompletion, 120);
            return;
          }


          stopRevealRitual();
          showScreen("email");
          saveState();
          jumpToQuizTop();
        }, minimumRevealDuration);


        return;
      }


      if (visibleScreen === "email" && state.finalDominant) {
        activateQuizLayout();
        showScreen("email");
        return;
      }


      if (visibleScreen === "result" && state.finalDominant) {
        activateQuizLayout();
        showScreen("result");
        renderResult(state.finalDominant, state.finalSecond, state.finalPercentages);
        return;
      }


      showScreen("intro");
      deactivateQuizLayout();
    }


    function getVisibleScreen() {
      if (questionScreen && questionScreen.style.display !== "none") return "question";
      if (revealScreen && revealScreen.style.display !== "none") return "reveal";
      if (emailGate && emailGate.style.display !== "none") return "email";
      if (resultScreen && resultScreen.style.display !== "none") return "result";
      return "intro";
    }


    function findInQuiz(root) {
      for (let i = 1; i < arguments.length; i++) {
        const el = root.querySelector(arguments[i]);
        if (el) return el;
      }
      return null;
    }
  }
});

